import { CONTACT } from "../data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#09090B] text-white pt-12 pb-28 md:py-12"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid sm:grid-cols-2 gap-8">
        <div>
          <p className="font-anton uppercase text-2xl tracking-wide">
            ONE WAY TRANSPORT
          </p>
          <p className="mt-2 text-zinc-400">Usługi sprzętem Bobcat</p>
        </div>
        <div className="sm:text-right">
          <p className="text-zinc-400 text-sm uppercase tracking-widest">
            Kontakt
          </p>
          <a
            href={CONTACT.emailLink}
            className="block mt-1 hover:text-[#DC2626] transition-colors"
          >
            {CONTACT.email}
          </a>
          <a
            href={CONTACT.phoneLink}
            className="block hover:text-[#DC2626] transition-colors text-zinc-300"
          >
            Telefon: {CONTACT.phone}
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-10 pt-6 border-t border-zinc-800">
        <p className="text-zinc-500 text-sm">
          © {new Date().getFullYear()} ONE WAY TRANSPORT. Wszelkie prawa
          zastrzeżone.
        </p>
      </div>
    </footer>
  );
};
